/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/grado'

export default {
    get: params => {
        let customRoute = `${route}?expand=campus,seccion,countgrupos,status_description&search=${params.filter}`
        switch (params.gradoEstado) {
            case "2": customRoute = `${route}?estado=1&expand=campus,seccion,countgrupos,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=campus,seccion,countgrupos,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getGradoDetails: (payload) => Api().get(`${route}/${payload.id}?expand=campus,seccion,status_description`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=campus,seccion,countgrupos,status_description`, payload),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=campus,seccion,countgrupos,status_description,history`, { crossDomain: true }),
    put: payload => Api().put(`${route}/${payload.id}?expand=campus,seccion,countgrupos,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=campus,seccion,countgrupos,status_description`)
}
